document.addEventListener("DOMContentLoaded", function () {
  let form = document.getElementById("ContactForm");
  if (!form) return;

  const MIN_QTY = 1;
  const MSG_REQUIRED = "Campo obrigatório";
  const MSG_INVALID_NUMBER = "Insira um número válido";
  const MSG_MIN_QTY = "Somente atendemos pedidos a partir de 1 unidade.";
  const isCorporateForm = !!form.closest(".corporate-sale-form");

  function getRequiredFields() {
    return Array.from(form.querySelectorAll(".input-required")).filter((input) => {
      if (input.disabled) return false;
      const conditional = input.closest(".corporate-form__conditional");
      if (conditional && conditional.hasAttribute("hidden")) return false;
      return true;
    });
  }

  function removeFieldErrorMessage(input) {
    const error = input.parentNode.querySelector(".contact__field-error");
    if (error) error.remove();
    input.removeAttribute("aria-invalid");
    const fieldContainer = input.closest(".field");
    if (fieldContainer) fieldContainer.removeAttribute("aria-invalid");
  }

   function showFieldErrorMessage(input, message) {
    removeFieldErrorMessage(input);
    const errorMessage = document.createElement("small");
    errorMessage.className = "contact__field-error";
    errorMessage.innerHTML = `
      <span class="visually-hidden">Erro: </span>
      <span class="form__message">
        <svg aria-hidden="true" focusable="false" viewBox="0 0 13 13" width="13" height="13">
          <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
          <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/>
          <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>
        </svg>
        ${message}
      </span>
    `;
    input.parentNode.appendChild(errorMessage);
    input.setAttribute("aria-invalid", "true");
    const fieldContainer = input.closest(".field");
    if (fieldContainer) fieldContainer.setAttribute("aria-invalid", "true");
  }

function getFieldErrorMessage(field) {
  const value = field.value == null ? "" : String(field.value).trim();

  // Validação específica para quantidade
  if (field.id === "ContactForm-quantity-of-copies") {
    if (value === "") return MSG_REQUIRED;
    const n = Number(value);
    if (!Number.isFinite(n)) return MSG_INVALID_NUMBER;
    if (n < MIN_QTY) return MSG_MIN_QTY;
    return null;
  }

  // Validação específica para e-mail
  if (field.id === "ContactForm-email") {
    if (value === "") return MSG_REQUIRED;
    // regex simples e eficaz para validar formato de e-mail
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      return "Digite um e-mail válido";
    }
    return null;
  }

  return value ? null : MSG_REQUIRED;
}

 function validateField(input, showError = true) {
    const msg = getFieldErrorMessage(input);
    if (msg) {
      if (showError) showFieldErrorMessage(input, msg);
      return false;
    } else {
      removeFieldErrorMessage(input);
      return true;
    }
  }

  form.addEventListener(
    "blur",
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement)) return;
      if (!input.classList.contains("input-required")) return;
      validateField(input, true);
    },
    true
  );

  form.addEventListener("input", (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement)) return;
    if (!input.classList.contains("input-required")) return;
    validateField(input, false);
  });

  function validateForm(event) {
    let isValid = true;

    if (isCorporateForm) {
      const interestEvent = new CustomEvent("corporate-form:validate-interest", {
        detail: { isValid: true },
        cancelable: true,
      });
      form.dispatchEvent(interestEvent);
      if (!interestEvent.detail.isValid) isValid = false;
    }

    getRequiredFields().forEach((input) => {
      if (!validateField(input, true)) {
        if (isValid) input.focus();
        isValid = false;
      }
    });
    if (!isValid && event) {
      event.preventDefault();
      event.stopPropagation();
    }
    return isValid;
  }

  form.addEventListener("submit", function(e){
    if(!validateForm(e)) {
      // Garantir que nada prossiga
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
    return true;
  });
});